import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { NgIf } from '@angular/common';
import {ChatLibraryCreative, CreativeCardProps} from '../../models/chat-library.models';
import { MediaThumbnailComponent } from '../media-thumbnail/media-thumbnail.component';
import { PlatformIconsComponent } from '../platform-icons/platform-icons.component';
import { DashboardService } from '../../../../../services/dashboard.service';
import { environment } from '../../../../../../environments/environment';

@Component({
  selector: 'app-creative-card',
  standalone: true,
  imports: [NgIf, MediaThumbnailComponent, PlatformIconsComponent],
  templateUrl: './creative-card.component.html',
  styleUrl: './creative-card.component.scss',
})
export class CreativeCardComponent {
  @Input({ required: true }) card!: CreativeCardProps;
  @Output() cardClicked = new EventEmitter<CreativeCardProps>();

  private dashboardService = inject(DashboardService);

  get thumbnailUrl(): string {
    return this.card.creativeUrl;
  }

  get brandLogoUrl(): string {
    return this.dashboardService.getBrandIcon(this.card.brandKey);
  }

  onClick(): void {
    this.cardClicked.emit(this.card);
  }
}
